import React from "react"
import styles from "./index.module.less"
import cx from "clsx"

export default function Legend(props) {
  const { title, extra, ...rest } = props

  return (
    <legend {...rest} className={cx(styles.legendFormStyle)}>
      {title}
      {extra && <div>{extra}</div>}
    </legend>
  )
}
